import "../../../styles/Colors.css";
import "../styles/CalendarStyle.css";
import "../../../styles/Fonts.css";
import "../../../styles/Buttons.css";
import AddfromCalen from "./AddfromCalen";
import CalendarEmptyState from "./CalendarEmptyState";
import { baseURL, useFetch } from "../../../custom/api";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AddFoodModal from "../../groups/components/AddFoodModal";
import { useGroupApi } from "../../groups/groupApi";
import { toFarsiNumber } from "../../../custom/helpers";
import { notifyUnlocked } from "../../../components/achievements/AchievementUnlockToast";
// import persian_fa from "react-date-object/locales/persian_fa.js";
import persian from "react-date-object/calendars/persian.js";
import persian_fa from "react-date-object/locales/persian_fa.js";
// import gregorian from "react-date-object/locales/gregorian_en.js";
import DateObject from "react-date-object";
// var  = require("date-object/calendars/cjs/gregorian");



const MEAL_ORDER = ["breakfast", "snack1", "lunch", "snack2", "dinner", "snack3"];

const options = [
  { breakfast: "صبحانه", snack1: "میانوعده صبح" },
  {
    lunch: "نهار",
    snack2: "میانوعده عصر",
  },
  {
    dinner: "شام",
    snack3: "میانوعده شب",
  },
];

let locations = {
  breakfast: 0,
  snack1: 0,
  lunch: 1,
  snack2: 1,
  dinner: 2,
  snack3: 2,
};

function Week({ week }) {
  const [calendarData, setCalendarData] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const [adding, setAdding] = useState(false);
  const [busy, setBusy] = useState(false);
  const { json } = useGroupApi();
  let startDate = new Date(week[0].convert()).toISOString().substring(0, 10);
  let endDate = new Date(week[6].convert()).toISOString().substring(0, 10);

  const { myFetch } = useFetch();

  useEffect(() => {
    setLoaded(false);
    const fetchData = async () => {
      let body = { start_date: startDate, end_date: endDate };
      const resp = await myFetch(`calendar/get`, {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        body: JSON.stringify(body),
      });
      const r = await resp.json();
      setCalendarData(r);
      setLoaded(true);
    };
    fetchData();
  }, [startDate, endDate, reloadKey]);

  const dayIsoOf = (elem) => new Date(elem.convert()).toISOString().substring(0, 10);
  const todayLabel = new DateObject({ date: new Date(), locale: persian_fa }).setCalendar(persian).format("dddd DD MMMM");
  const dayOptions = week.map((elem) => {
    const label = elem.setCalendar(persian).format("dddd DD MMMM");
    return { iso: dayIsoOf(elem), label: toFarsiNumber(label), isToday: label === todayLabel };
  });
  const occupiedByDay = {};
  calendarData.forEach((c) => {
    (occupiedByDay[c.date] = occupiedByDay[c.date] || []).push(c.meal_type);
  });

  const openAdd = (iso) => setAdding({ day: iso || (dayOptions.find((d) => d.isToday) || dayOptions[0]).iso });
  const closeAdd = () => setAdding(false);

  const afterAdd = (r, okMessage) => {
    toast.success(okMessage);
    if (r.newly_unlocked && r.newly_unlocked.length > 0) notifyUnlocked(r.newly_unlocked);
    closeAdd();
    setReloadKey((k) => k + 1);
  };

  const addRecipe = async (recipe, meal, day) => {
    setBusy(true);
    try {
      const r = await json("calendar/add", "POST", { recipe_id: recipe.recipe_id, meal_type: meal, date: day });
      if (r.message === "success") afterAdd(r, "غذا به تقویم اضافه شد");
      else toast.error("مشکلی پیش اومد :( دوباره غذا رو اضافه کن");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  // A custom food is only a calendar entry (the exact name typed). No recipe is created;
  // the server also queues the name as a request for the FoodPlanner team.
  const addCustom = async (name, meal, day) => {
    setBusy(true);
    try {
      const r = await json("calendar/add-custom", "POST", { food_name: name, meal_type: meal, date: day });
      if (r.already_there) {
        toast.info("این غذا همین الان توی این وعده هست");
        closeAdd();
      } else if (r.existing_recipe) {
        afterAdd(r, "به تقویم اضافه شد · این غذا توی فودپلنر دستور پخت هم داره، می‌تونی از لیست غذاها پیداش کنی");
      } else {
        afterAdd(r, "به تقویمت اضافه شد؛ بررسی می‌کنیم براش دستور پخت اضافه کنیم");
      }
    } catch (e) {
      toast.error(e.message);   // sheet stays open so the typed name isn't lost
    } finally {
      setBusy(false);
    }
  };

  const addSheet = adding ? (
    <AddFoodModal
      title="افزودن غذا به تقویم"
      mealType={
        MEAL_ORDER.find((m) => !(occupiedByDay[adding.day] || []).includes(m)) || "breakfast"
      }
      days={dayOptions}
      initialDay={adding.day}
      occupiedByDay={occupiedByDay}
      busy={busy}
      onPick={addRecipe}
      allowCustom
      customHint="به تقویمت"
      onPickCustom={addCustom}
      onClose={closeAdd}
    />
  ) : null;

  if (loaded && calendarData.length === 0) {
    return (
      <>
        <CalendarEmptyState onAddFood={() => openAdd()} />
        {addSheet}
      </>
    );
  }

  const days = week.map((elem) => {
    let className;
    let today = new DateObject({
      date: new Date(),
      locale: persian_fa,
    });

    // console.log(myDay.setCalendar(persian).format("dddd DD MMMM"));

    if (
      elem.setCalendar(persian).format("dddd DD MMMM") ===
      today.setCalendar(persian).format("dddd DD MMMM")
    ) {
      className = "marginBottom1 rightAlign today-date";
    } else {
      className = "marginBottom3 rightAlign";
    }

    // A stable per-day key (not Math.random()) - random keys forced React to
    // fully remount this whole day's subtree (and every AddfromCalen inside
    // it, wiping its local "cooked" state) on any unrelated re-render.
    let dayIso = new Date(elem.convert()).toISOString().substring(0, 10);

    return (
      <div className={className} key={dayIso}>
        <div className="heading-2 paddingSide5 paddingTop1 marginBottom8p spc-between centerItemAlign">
          {elem.setCalendar(persian).format("dddd DD MMMM")}
          <button
            type="button"
            className="calAddBtn"
            onClick={() => openAdd(dayIso)}
            aria-label="افزودن غذا به این روز"
          >
            <span className="icon-iconplus"></span>
          </button>
        </div>
        <div className="meals-body">
          {options.map((element, groupIndex) => {
            let mealTypes = Object.keys(element);
            return (
              <div className="" key={`${dayIso}-group-${groupIndex}`}>
                {mealTypes.map((mealType) => {
                  let farsiMealType = options[locations[mealType]][mealType];
                  let recipeInfo = calendarData.filter((calendarElem) => {
                    return (
                      calendarElem.date === dayIso &&
                      calendarElem.meal_type === mealType
                    );
                  })[0];

                  return (
                    <>
                      {
                        recipeInfo ? (
                          // render if variable is not null
                          <AddfromCalen
                            title={farsiMealType}
                            mealType={mealType}
                            image={
                              recipeInfo?.image_path &&
                              `${baseURL}/${recipeInfo.image_path}`
                            }
                            name={recipeInfo?.recipe_name}
                            isCustom={!!recipeInfo?.is_custom}
                            recipeId={recipeInfo?.recipe_id}
                            date={recipeInfo?.date}
                            calendarData={calendarData}
                            setCalendarData={setCalendarData}
                            calendarId={recipeInfo?.calendar_id}
                            initialCooked={recipeInfo?.cooked}
                            key={recipeInfo?.calendar_id ?? `${dayIso}-${mealType}`}
                          />
                        ) : // render if variable is null
                        null
                        // <span className="icon-iconplus heading-2 grey-3"></span>
                      }
                    </>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  });

  return (
    <>
      {days}
      {addSheet}
    </>
  );
}
export default Week;
